import { Component } from '@angular/core';
import { ICON, ICON_STYLE } from '@core/util/icon';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BusinessState } from '@state/business';
import { UrlService } from 'src/app/shared/services/url/url.service';

@Component({
	selector: 'app-manage',
	templateUrl: './manage.component.html',
	standalone: false,
})
export class ManageComponent {
	financesGeneralUrl = UrlService.Manage_Finances_General();
	checklistUrl = UrlService.Manage_Checklist();
	ICON = ICON;
	ICON_STYLE = ICON_STYLE;
	manageBillingUrl = UrlService.Manage_Business_Billing();
	manageBusinessDefaultsUrl = UrlService.Manage_Business_Defaults();
	manageBusinessDetailsUrl = UrlService.Manage_Business_Details();
	manageBusinessDocumentStylingUrl = UrlService.Manage_Document_Styling();
	manageBusinessSecurityUrl = UrlService.Manage_Business_Security();
	manageBusinessDocumentTemplatesUrl =
		UrlService.Manage_Business_Template_Documents();
	manageBusinessRequisitionTemplatesUrl =
		UrlService.Manage_Business_Template_Requisitions();
	manageIntegrationsUrl = UrlService.Manage_Integrations();
	manageInvitesUrl = UrlService.Manage_Invites();
	manageUsersUrl = UrlService.Manage_Users();
	manageTrustAccountsUrl = UrlService.Manage_Trust_Accounts();

	@SelectSnapshot(BusinessState.isCollege) isCollege;
}
